module.exports = __webpack_public_path__ + "img/sankaku_62_red.0bd64284.png";